import { Box, Skeleton } from '@chakra-ui/react';
import type React from 'react';

interface NotificationDetailsSkeletonProps {
  detailRows?: number;
}

const NotificationDetailsSkeleton: React.FC<NotificationDetailsSkeletonProps> = ({ detailRows = 7 }) => {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box bg={{ base: 'gray.100', _dark: 'gray.900' }} p={4} px={6} borderRadius="md">
        <Box borderLeft="4px solid" borderColor={{ base: 'gray.300', _dark: 'gray.700' }} pl={2}>
          <Skeleton
            height="20px"
            width="60%"
            mb={2}
            variant="shine"
            css={{
              '--start-color': {
                base: 'colors.gray.200',
                _dark: 'colors.gray.700',
              },
              '--end-color': { base: '#d4e4e182', _dark: '#47545157' },
            }}
          />
          <Skeleton
            height="16px"
            width="30%"
            mb={2}
            variant="shine"
            css={{
              '--start-color': {
                base: 'colors.gray.200',
                _dark: 'colors.gray.700',
              },
              '--end-color': { base: '#d4e4e182', _dark: '#47545157' },
            }}
          />
          <Skeleton
            height="12px"
            width="20%"
            variant="shine"
            css={{
              '--start-color': {
                base: 'colors.gray.200',
                _dark: 'colors.gray.700',
              },
              '--end-color': { base: '#d4e4e182', _dark: '#47545157' },
            }}
          />
        </Box>
      </Box>

      <Box display="flex" flexDirection="column" gap={2}>
        {Array.from({ length: detailRows }).map((_, index) => (
          <Box
            key={index}
            bg={{ base: 'gray.50', _dark: 'gray.800' }}
            p={1}
            mt={1}
            borderRadius="md"
            display="flex"
            gap={2}
          >
            <Skeleton
              height="16px"
              width={350}
              variant="shine"
              css={{
                '--start-color': {
                  base: 'colors.gray.200',
                  _dark: 'colors.gray.700',
                },
                '--end-color': { base: '#d4e4e182', _dark: '#47545157' },
              }}
            />
            <Skeleton
              height="16px"
              width="40%"
              variant="shine"
              css={{
                '--start-color': {
                  base: 'colors.gray.200',
                  _dark: 'colors.gray.700',
                },
                '--end-color': { base: '#d4e4e182', _dark: '#47545157' },
              }}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default NotificationDetailsSkeleton;

